import { IconButton, Typography, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Modal } from '../../../components/modals/Modal';
import PrivacyPolicy from '../../../pages/NewFigma/PrivacyPolicy';
import type { PrivacyPolicyModalProps } from '../types';

export function PrivacyPolicyModal({ open, onClose }: PrivacyPolicyModalProps) {

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        zIndex: (theme) => theme.zIndex.modal + 1,
        '& > .MuiBox-root': {
          width: '100%',
          maxWidth: 900,
          borderRadius: '16px',
        },
      }}
    >
      <Modal.Header>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: 2,
            py: 1.5,
            borderBottom: 1,
            borderColor: 'divider',
            flexShrink: 0,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Privacy Policy
          </Typography>
          <IconButton aria-label="Close privacy policy" onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </Modal.Header>
      <Box
        className="custom-scrollbar"
        sx={{
          maxHeight: 'calc(95vh - 64px)',
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <PrivacyPolicy variant="modal" />
      </Box>
    </Modal>
  );
}

export default PrivacyPolicyModal;
